import type { ReactNode } from "react";

type EnumsContextProps = {
  children: ReactNode;
};

/**
 * EnumContext - Chargement des enums métier au démarrage
 *
 * Ce composant est préparé pour charger les enums depuis l'API
 * (ex: types de studios, statuts de candidature, etc.)
 * et les stocker dans Redux via le store `enums`.
 *
 * TODO: Ajouter les appels API pour les enums métier Paul Janet
 * Exemple:
 *   const { data: studioTypes } = useGetStudioTypesQuery();
 *   useEffect(() => { dispatch(setStudioTypes(studioTypes)); }, [studioTypes]);
 */
function EnumsContext({ children }: EnumsContextProps) {
  // Placeholder - les enums métier seront chargés ici
  return children;
}

export default EnumsContext;
